import { useState } from "react";
import { createShareLink, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Share2, Copy, Check, ExternalLink } from "lucide-react";

export function ShareButton({ docType, docId, variant = "outline", size = "sm", label = "Share" }) {
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);
  const [copied, setCopied] = useState(false);

  const create = async () => {
    setBusy(true);
    try {
      const r = await createShareLink(docType, docId);
      setUrl(r.url); setOpen(true);
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); setCopied(true); setTimeout(() => setCopied(false), 1500); }
    catch { toast.error("Copy failed — select and copy manually"); }
  };

  return (
    <>
      <Button variant={variant} size={size} onClick={create} disabled={busy} data-testid="share-doc-btn"><Share2 className="w-4 h-4 mr-1.5" /> {busy ? "Creating…" : label}</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="share-link-dialog">
          <DialogHeader>
            <DialogTitle>Shareable link</DialogTitle>
            <DialogDescription>Anyone with this link can view the document — no login needed. Revoke it anytime from Settings.</DialogDescription>
          </DialogHeader>
          <div className="flex gap-2">
            <Input readOnly value={url} className="text-sm" data-testid="share-link-url" onFocus={(e) => e.target.select()} />
            <Button onClick={copy} className="bg-[#0B132B] hover:bg-[#1C2541]" data-testid="copy-share-link">{copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}</Button>
          </div>
          <a href={url} target="_blank" rel="noreferrer" className="text-sm text-[#0B132B] inline-flex items-center gap-1 mt-1"><ExternalLink className="w-3.5 h-3.5" /> Open preview</a>
        </DialogContent>
      </Dialog>
    </>
  );
}
